import { render } from "./UiCollapse.vue?vue&type=template&id=6fe7a234&ts=true"
import script from "./UiCollapse.vue?vue&type=script&lang=ts"
export * from "./UiCollapse.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__